import {
  Timestamp,
  arrayUnion,
  doc,
  setDoc,
  updateDoc,
} from 'firebase/firestore';
import {httpsCallable} from 'firebase/functions';
import {
  FirestoreCollection,
  HubblGroupSuggestion,
  Keys,
  NotificationDataType,
  Palette,
  createBreakId,
  createHubblAdminMockUser,
  createInitialSystemMessage,
  getRandomPrimaryColor,
} from 'hubbl-shared';
import {HubblGroupDTO} from '../models/hubbl/HubblGroupDTO';
import {firebaseFunctions, firestore} from './firebase';
import {mapUserToUserDTO} from './utils/map-incoming-users/mapUserToUserDTO';

const onMoveAdminToCompany = async (
  companyId: string,
  deleteOldUser: boolean,
  userId: string,
) => {
  const callableFunc = httpsCallable(
    firebaseFunctions,
    //TODO: Add to constant in shared
    'onMoveAdminToCompany',
  );
  return callableFunc({
    adminId: userId,
    newCompanyId: companyId,
    deleteAdminFromExstingCompany: deleteOldUser,
  })
    .then(result => {
      console.log(result.data);
      const data = result.data;
      return data;
    })
    .catch(error => {
      console.log(`error: ${JSON.stringify(error)}`);
      throw error;
    });
};

const sendNotificationToCompany = async (
  companyId: string,
  notificationTitle: string,
  notificationDescription: string,
  notificationData: NotificationDataType,
  userIds?: string[],
) => {
  const callableFunc = httpsCallable(
    firebaseFunctions,
    //TODO: Add to constant in shared
    'sendNotificationToCompany',
  );
  return callableFunc({
    companyId,
    notificationTitle,
    notificationDescription,
    notificationData,
    userIds,
  })
    .then(result => {
      console.log(result.data);
      const data = result.data;
      return data;
    })
    .catch(error => {
      console.log(`error: ${JSON.stringify(error)}`);
      throw error;
    });
};

interface AddHubblGroupSuggestionProps {
  companyId: string;
  description: string;
  location: string | null;
  emoji: string;
  /**
   * Use format: 2024-03-07T12:00:00.000
   */
  startDateTime: string;
  endDateTime?: string;
}

const addHubblGroupSuggestion = async ({
  companyId,
  description,
  emoji,
  endDateTime,
  location,
  startDateTime,
}: AddHubblGroupSuggestionProps) => {
  if (!companyId || companyId === '') {
    return false;
  }
  const promise = new Promise<void>(async (resolve, reject) => {
    const hubblAdmin = createHubblAdminMockUser({companyId});

    console.log('🚀🚀🚀🚀 ~ promise ~ hubblAdmin:', hubblAdmin);
    const hubblGroup: HubblGroupDTO = {
      isRepeatedHubbl: false,
      attendees: [],
      companyId,
      endDateTime: endDateTime
        ? Timestamp.fromDate(new Date(endDateTime))
        : null,
      description: {
        da: description,
        en: description,
      },
      emoji: emoji,
      location: location,
      tasks: [],
      id: createBreakId({userId: hubblAdmin.id, breakCreated: new Date()}),
      isRepeatEnabled: false, //SHOULD NOT BE TRUE
      messages: [createInitialSystemMessage()],
      officeId: Keys.defaultOffice,
      startDateTime: Timestamp.fromDate(new Date(startDateTime)),
      filters: null,
      attendeeIds: [],
      color: getRandomPrimaryColor() ?? Palette.primaryCherokee,
      createdDateTime: Timestamp.fromDate(new Date()),
      isGroupFilled: false,
      isHubblPassed: false,
      labels: [],
      maxAttendees: null,
      spaceId: Keys.defaultSpace,
      type: 'group',
      creator: mapUserToUserDTO(hubblAdmin),
      extraDetails: null,
      declinedUserIds: [],
      declinedUsers: [],
    };
    try {
      const companyRef = doc(
        firestore,
        FirestoreCollection.Companies,
        companyId,
      );

      const hubblRef = doc(
        companyRef,
        FirestoreCollection.Hubbles,
        hubblGroup.id,
      );

      await setDoc(hubblRef, hubblGroup);

      resolve();
    } catch (error) {
      reject(error);
    }
  });
  return promise;
};

const addGeneralHubblSuggestion = async (
  hubblSuggest: HubblGroupSuggestion,
) => {
  const promise = new Promise<void>(async (resolve, reject) => {
    try {
      const functionsPersistStoreRef = doc(
        firestore,
        FirestoreCollection.FunctionsPersistStore,
        Keys.defaultFunctionsPersistStoreId,
      );

      await updateDoc(functionsPersistStoreRef, {
        hubblGroupSuggestions: arrayUnion(hubblSuggest),
      });

      resolve();
    } catch (error) {
      reject(error);
    }
  });
  return promise;
};

export const superAdmin = {
  sendNotificationToCompany,
  addHubblGroupSuggestion,
  onMoveAdminToCompany,
  addGeneralHubblSuggestion,
};
